import {
  EventStatusId,
  VolleyballEventStatusId,
} from '@collector/sportsapi-client-legacy'

export const pitchOverlaySupportedStatuses: EventStatusId[] = [
  VolleyballEventStatusId.FinishedAwardedWin,
  VolleyballEventStatusId.Abandoned,
  VolleyballEventStatusId.Postponed,
  VolleyballEventStatusId.Cancelled,
]
